import { useState } from 'react';
import { NAV_ITEMS } from '../constants/navigation.js';

const LOGO_URL =
	'https://res.cloudinary.com/deagvpc2p/image/upload/f_webp,q_auto/v1770486714/Logotipo_Fondo_bgk6ah.png';

function Navbar() {
	const [isMenuOpen, setIsMenuOpen] = useState(false);

	const closeMenu = () => setIsMenuOpen(false);

	return (
		<header className='fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-black/25 backdrop-blur-xl'>
			<nav
				aria-label='Navegación principal'
				className='mx-auto flex w-full max-w-[1400px] items-center justify-between gap-4 px-4 py-4 sm:px-6 lg:px-10 lg:py-5'
			>
				<a
					href='#inicio'
					className='flex min-w-0 items-center gap-2 sm:gap-3 lg:gap-5'
				>
					<img
						src={LOGO_URL}
						alt='Logotipo de CodingFlash'
						loading='eager'
						decoding='async'
						referrerPolicy='no-referrer'
						className='h-8 w-8 rounded-full object-cover object-center sm:h-9 sm:w-9 lg:h-10 lg:w-10'
					/>
					<span className='pr-1 font-display text-sm font-bold uppercase leading-none tracking-[0.06em] text-primary sm:text-lg sm:tracking-[0.08em] lg:text-[2.15rem] lg:tracking-[0.12em]'>
						CodingFlash
					</span>
				</a>

				<div className='ml-auto flex items-center gap-3 sm:gap-4 lg:hidden'>
					<button
						type='button'
						aria-label={isMenuOpen ? 'Cerrar menú' : 'Abrir menú'}
						aria-expanded={isMenuOpen}
						onClick={() => setIsMenuOpen(open => !open)}
						className='inline-flex h-11 w-11 items-center justify-center border border-primary/20 text-primary transition-colors duration-200 hover:border-primary/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/70 focus-visible:ring-offset-2 focus-visible:ring-offset-black'
					>
						<span className='relative block h-4 w-5'>
							<span
								className={`absolute left-0 top-0 h-[2px] w-5 bg-current transition-transform duration-300 ${
									isMenuOpen ? 'translate-y-[7px] rotate-45' : ''
								}`}
							/>
							<span
								className={`absolute left-0 top-[7px] h-[2px] w-5 bg-current transition-opacity duration-300 ${
									isMenuOpen ? 'opacity-0' : 'opacity-100'
								}`}
							/>
							<span
								className={`absolute left-0 top-[14px] h-[2px] w-5 bg-current transition-transform duration-300 ${
									isMenuOpen ? '-translate-y-[7px] -rotate-45' : ''
								}`}
							/>
						</span>
					</button>
				</div>

				<div className='ml-auto hidden items-center gap-6 lg:flex lg:gap-8 xl:gap-10'>
					<ul className='hidden items-center gap-6 lg:flex xl:gap-8'>
						{NAV_ITEMS.map(item => (
							<li key={item.label}>
								<a
									href={item.href}
									className='font-display text-xs font-bold uppercase tracking-[0.14em] text-primary/55 transition-colors duration-300 hover:text-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/70 focus-visible:ring-offset-2 focus-visible:ring-offset-black'
								>
									{item.label}
								</a>
							</li>
						))}
					</ul>

					<a
						href='#contacto'
						className='group relative inline-flex overflow-hidden whitespace-nowrap border border-primary/20 bg-accent px-5 py-3 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/70 focus-visible:ring-offset-2 focus-visible:ring-offset-black xl:px-7'
					>
						<span className='absolute inset-0 translate-y-full bg-primary transition-transform duration-300 ease-out group-hover:translate-y-0' />
						<span className='relative z-10 font-display text-xs font-bold uppercase tracking-[0.14em] text-primary transition-colors duration-300 group-hover:text-accent'>
							Quiero una propuesta
						</span>
					</a>
				</div>
			</nav>

			<div
				className={`overflow-hidden border-t border-white/10 bg-black/70 backdrop-blur-xl transition-[max-height,opacity] duration-300 lg:hidden ${
					isMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
				}`}
			>
				<div className='space-y-1 px-4 py-4 sm:px-6'>
					{NAV_ITEMS.map(item => (
						<a
							key={item.label}
							href={item.href}
							onClick={closeMenu}
							className='block py-3 font-display text-xs font-bold uppercase tracking-[0.14em] text-primary/70 transition-colors duration-300 hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/70 focus-visible:ring-offset-2 focus-visible:ring-offset-black'
						>
							{item.label}
						</a>
					))}

					<a
						href='#contacto'
						onClick={closeMenu}
						className='group relative mt-3 inline-flex w-full justify-center overflow-hidden whitespace-nowrap border border-primary/20 bg-accent px-7 py-3 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/70 focus-visible:ring-offset-2 focus-visible:ring-offset-black'
					>
						<span className='absolute inset-0 translate-y-full bg-primary transition-transform duration-300 ease-out group-hover:translate-y-0' />
						<span className='relative z-10 font-display text-xs font-bold uppercase tracking-[0.14em] text-primary transition-colors duration-300 group-hover:text-accent'>
							Quiero una propuesta
						</span>
					</a>
				</div>
			</div>
		</header>
	);
}

export default Navbar;
